import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const sizeToClassNameMap = {
  xxs: 'cuiRhythm--xxs',
  xs: 'cuiRhythm--xs',
  s: 'cuiRhythm--s',
  m: 'cuiRhythm--m',
  l: 'cuiRhythm--l',
  xl: 'cuiRhythm--xl',
  xxl: 'cuiRhythm--xxl',
};

export const SIZES = Object.keys(sizeToClassNameMap);

export const CuiRhythm = ({ children, className, size, ...rest }) => {
  const classes = classNames(className, sizeToClassNameMap[size]);

  let renderedChildren;

  if (
    Array.isArray(children) ||
    typeof children === 'string' ||
    typeof children === 'undefined'
  ) {
    renderedChildren = <div>{children}</div>;
  } else {
    renderedChildren = children;
  }

  return cloneElement(renderedChildren, {
    className: classes,
    ...rest,
  });
};

CuiRhythm.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.string,
};

CuiRhythm.defaultProps = {
  children: undefined,
  className: undefined,
  size: 'm',
};



// WEBPACK FOOTER //
// ./ui/components/rhythm/Rhythm.js